import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanDetailsComponent } from './plan-details.component';
import { PlanDetailsRoutingModule } from './plan-details-routing.module';
import { PlanDetailsService } from './plan-details.service';
import { ViewEFL } from './plan-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { PipeModule } from '../shared/pipe/pipe.module';
import { CdkTableModule } from '@angular/cdk/table';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { 
  MatAutocompleteModule,
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatCardModule } from '@angular/material';

@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    PlanDetailsRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    PipeModule.forRoot(),
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatCardModule
  ],
  bootstrap: [ViewEFL],
  providers: [PlanDetailsService],
  declarations: [ 
    PlanDetailsComponent,
    ViewEFL
  ]
})
export class PlanDetailsModule { }



// WEBPACK FOOTER //
// ./src/app/plan-details/plan-details.module.ts